import axiosInstance from "utils/axios";

export const getCareers = async (careers) => {
  try {
    const res = await axiosInstance(`careers/list`, {
      params: {
        careers: JSON.stringify(careers),
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
    throw new Error("Error while fetching careers");
  }
};
